import { useHistory } from 'react-router-dom';
import { useMemo, useState } from 'react';
import useDidUpdateEffect from 'new/hooks/useDidUpdateEffect';

export default function useUpdateSearch() {
  const history = useHistory();
  const initialParams = new URLSearchParams(history.location.search);
  const id = initialParams.get('id');
  const type = initialParams.get('type');
  const [data, setData] = useState({ type, id });

  function updateUrl(data) {
    const params = new URLSearchParams(history.location.search);
    params.set('type', data.type);
    params.set('id', data.id);
    history.replace({
      pathname: history.location.pathname,
      search: params.toString(),
    });
  }

  useDidUpdateEffect(() => {
    updateUrl(data);
  }, [data]);

  return useMemo(() => {
    return { ...data, setData };
  }, [data]);
}
